import { CLOSE_MODAL, OPEN_MODAL } from './Modals.actions';

const initialState = {
    openModalId: null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CLOSE_MODAL:
            return {
                ...state,
                openModalId: null
            };
        case OPEN_MODAL:
            return {
                ...state,
                openModalId: action.modalId
            };
        default:
            return state;
    }
}
